import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastrModule } from "ngx-toastr";

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMomentDateModule } from "@angular/material-moment-adapter";

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { CompanyComponent } from './pages/company/company.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './pages/login/login.component';
import { UserComponent } from "./pages/user/user.component";
import { AuthGuard } from "./auth.guard";

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ReporteComponent } from "./pages/reporte/reporte.component";
import { TableFilterReportesComponent } from "./views/tables/table-filter-reportes/table-filter-reportes.component";
import { FormFilterReportesComponent } from "./views/forms/form-filter-reportes/form-filter-reportes.component";
import { Excel } from "./utils/excel";
import { PDF } from "./utils/pdf";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxPaginationModule } from "ngx-pagination";
import { DetalleGestionComponent } from './pages/gestion/detalle-gestion.component';
import { OnBoardingComponent } from "./pages/onBoarding/onBoarding.component";
import { ParkingComponent } from "./pages/parking/parking.component";
import { ParkingLayoutComponent } from "./layouts/parking-layout/parking-layout.component";
import { FrontendIdInterceptor } from './frontend-id.interceptor';
import { TransactionComponent } from './pages/transaction/transaction.component';
import { StorageComponent } from './pages/transaction/components/storage/storage.component';
import { ReportsComponent } from './pages/transaction/components/reports/reports.component';
import { ConfigurationComponent } from './pages/transaction/components/configuration/configuration.component';
import { TransactionListComponent } from "./pages/transaction/components/transaction-list/transaction-list.component";
import { ContainerTypeConfigComponent } from './pages/transaction/components/configuration/container-type-config/container-type-config.component';
import { MovementReportsComponent } from './pages/transaction/components/movement-reports/movement-reports.component';

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    CompanyComponent,    
    ReporteComponent,
    TableFilterReportesComponent,
    FormFilterReportesComponent,
    LoginComponent,
    UserComponent,
    OnBoardingComponent,
    ParkingLayoutComponent,
    DetalleGestionComponent,
    TransactionComponent,
    StorageComponent,
    ReportsComponent,
    TransactionListComponent,
    ConfigurationComponent,
    ContainerTypeConfigComponent,
    MovementReportsComponent
  ],
  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes,{
    useHash: true,
    relativeLinkResolution: 'legacy'
}),
    SidebarModule,
    NavbarModule,
    ToastrModule.forRoot(),
    FooterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatInputModule,
    NgxSpinnerModule,
    MatFormFieldModule,
    NgxPaginationModule,
    NgbModule,
    NavbarModule
  ],
  providers: [
    AuthGuard,
    Excel,
    PDF,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FrontendIdInterceptor,
      multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
